module.exports = __webpack_public_path__ + "static/media/4.a9f9cbb8.jpg";